import type { TermsTranslations } from '../en-US/terms.translations';

export const termsTranslations: TermsTranslations = {
  title: 'Allgemeine Geschäftsbedingungen',
  lastUpdated: 'Zuletzt aktualisiert: 7. März 2024',
  sections: {
    introduction: {
      title: 'Einführung',
      content:
        'Willkommen bei BiteCritic! Diese Allgemeinen Geschäftsbedingungen regeln Ihre Nutzung unserer Plattform und Dienste. Durch die Nutzung von BiteCritic stimmen Sie diesen Bedingungen vollständig zu.',
    },
    userAgreement: {
      title: 'Nutzervereinbarung',
      content:
        'Durch die Erstellung eines Kontos bei BiteCritic stimmen Sie zu:',
      items: [
        'Genaue und wahrheitsgemäße Informationen anzugeben',
        'Die Sicherheit Ihres Kontos zu gewährleisten',
        'Die Verantwortung für alle Aktivitäten unter Ihrem Konto zu übernehmen',
        'Alle geltenden Gesetze und Vorschriften einzuhalten',
      ],
    },
    content: {
      title: 'Inhaltsrichtlinien',
      content: 'Bei der Nutzung von BiteCritic stimmen Sie zu:',
      items: [
        'Authentische und ehrliche Bewertungen zu teilen',
        'Geistiges Eigentum zu respektieren',
        'Keine schädlichen, beleidigenden oder unangemessenen Inhalte zu veröffentlichen',
        'Sich nicht an Spam oder irreführendem Verhalten zu beteiligen',
      ],
    },
    contentRights: {
      title: 'Inhaltsrechte und -aufbewahrung',
      content: 'Bezüglich Ihrer Inhalte auf BiteCritic:',
      items: [
        'Sie behalten das Eigentum an Ihren Inhalten, erteilen uns jedoch eine weltweite, nicht-exklusive, gebührenfreie Lizenz zur Nutzung, Anzeige, Verbreitung, Reproduktion, Änderung und Erstellung abgeleiteter Werke Ihrer Inhalte im Zusammenhang mit dem Dienst und für Werbe- und Marketingzwecke von BiteCritic, einschließlich, aber nicht beschränkt auf die Anzeige auf unserer Website, App und Drittanbieter-Plattformen wie sozialen Medien',
        'Wenn Sie Ihr Konto löschen, werden Ihre persönlichen Daten anonymisiert, aber Ihre Bewertungen und andere Beiträge können aufbewahrt werden',
        'Inhalte erscheinen nach der Kontolöschung als von einem "Anonymen Benutzer" gepostet',
        'Für die vollständige Löschung aller Inhalte müssen Sie uns direkt unter hurricanesoftwaresolutions@gmail.com kontaktieren',
        'Wir können anonymisierte Bewertungen weiterhin anzeigen, um den Wert der Plattform für alle Nutzer zu erhalten',
      ],
    },
    privacy: {
      title: 'Datenschutz und Daten',
      content:
        'Wir nehmen Ihren Datenschutz ernst. Durch die Nutzung von BiteCritic erkennen Sie an, dass:',
      items: [
        'Wir Ihre Daten wie in unserer Datenschutzrichtlinie beschrieben sammeln und verarbeiten',
        'Ihr öffentliches Profil und Ihre Bewertungen für andere Nutzer sichtbar sind',
        'Sie Ihre Datenschutzeinstellungen über Ihr Konto steuern können',
        'Wir Cookies und ähnliche Technologien verwenden',
      ],
    },
    community: {
      title: 'Community-Richtlinien',
      content: 'Als Mitglied der BiteCritic-Community stimmen Sie zu:',
      items: [
        'Andere Nutzer mit Respekt zu behandeln',
        'Keine Belästigung oder Diskriminierung anderer vorzunehmen',
        'Konstruktive und hilfreiche Beiträge zu leisten',
        'Unangemessene Inhalte oder Verhaltensweisen zu melden',
      ],
    },
    termination: {
      title: 'Kontokündigung',
      content: 'Wir behalten uns das Recht vor:',
      items: [
        'Konten zu sperren oder zu kündigen, die gegen diese Bedingungen verstoßen',
        'Inhalte zu entfernen, die gegen unsere Richtlinien verstoßen',
        'Dienste mit angemessener Ankündigung zu ändern oder einzustellen',
        'Nutzerdaten bei Kontolöschung zu anonymisieren, aber Inhalte beizubehalten',
        'Anfragen zur vollständigen Löschung per E-Mail innerhalb von 30 Tagen zu bearbeiten',
      ],
    },
  },
  agreement: {
    checkbox:
      'Ich habe die Allgemeinen Geschäftsbedingungen gelesen und stimme ihnen zu',
    required:
      'Sie müssen den Allgemeinen Geschäftsbedingungen zustimmen, um fortzufahren',
    view: 'Allgemeine Geschäftsbedingungen ansehen',
  },
};

export default termsTranslations;
